import { Text, View } from '@react-pdf/renderer';
import { createColumnHelper } from '@tanstack/react-table';
import { upperFirst } from 'lodash-es';
import { DateTime } from 'luxon';

import { commonStyles } from 'src/common/pdf/common.styles';
import { PDFTable } from 'src/common/pdf/PDFTable/PDFTable';
import { CreditCardPDF } from 'src/common/primitives/icon/CreditCardBrand/CreditCardBrand';
import { currencyFormatter } from 'src/features/billing/invoices/forms/cells/utils';
import { HydratedInvoiceRefundRow } from 'src/features/billing/invoices/types';

const createColumn = createColumnHelper<HydratedInvoiceRefundRow>();

const columns = [
  createColumn.display({
    id: 'date',
    size: 140,
    header() {
      return null;
    },
    cell({ row }) {
      return (
        <Text style={commonStyles.textSm}>
          {DateTime.fromISO(row.original.RefundDate).toLocaleString(
            DateTime.DATETIME_SHORT
          )}
        </Text>
      );
    },
  }),
  createColumn.display({
    id: 'card',
    size: 150,
    header() {
      return null;
    },
    cell({ row }) {
      if (row.original.paymentMethod.IsManual === 'True') {
        return (
          <Text
            style={[
              commonStyles.textSm,
              commonStyles.strong,
              commonStyles.upper,
            ]}
          >
            Cash
          </Text>
        );
      }

      return (
        <View style={[commonStyles.hstack, { gap: 2 }]}>
          <CreditCardPDF brand={row.original.paymentMethod.CardBrand} />
          <View style={commonStyles.textSm}>
            <Text style={commonStyles.strong}>
              {row.original.paymentMethod.CardHolderName}
            </Text>
            <Text>
              ({upperFirst(row.original.paymentMethod.CardBrand)} ending in{' '}
              {row.original.paymentMethod.CardLast4})
            </Text>
            <Text>Expiry {row.original.paymentMethod.CardExpirationDate}</Text>
          </View>
        </View>
      );
    },
  }),
  createColumn.display({
    id: 'amount',
    header() {
      return null;
    },
    cell({ row }) {
      const amount = parseInt(row.original.AmountCents) / 100;
      return (
        <View
          style={{ alignSelf: 'flex-end' }}
          data-testid={row.original.PaymentID}
        >
          <Text>{currencyFormatter(amount)}</Text>;
        </View>
      );
    },
  }),
];

interface ExpandedRefundsTableProps {
  data: HydratedInvoiceRefundRow[];
}
export function ExpandedRefundsTable({ data }: ExpandedRefundsTableProps) {
  return <PDFTable data={data} columns={columns} includeHeaderRow={false} />;
}
